import { RootState } from 'store';
import React, { useState } from 'react';
import { addAlert } from 'store/modules/snackBar';
import { useDispatch, useSelector } from 'react-redux';
import { CheckCircleOutline, CheckBoxOutlineBlank } from '@material-ui/icons';
import { Button, DatePicker, MdSpace, SmSpace, TextField } from 'm2m.components';
import { Drawer, Grid, Typography, Divider, Checkbox, colors } from '@material-ui/core';
import { WarningSign } from 'components/warningSign';
 
interface Props {
  open: boolean;
  onClose: () => void;
}

const ReenviarConviteDrawer: React.FC<Props> = (props) => {
  const { open = false, onClose } = props;
  const [email, setEmail] = useState<string>('');
  const [conviteUsuario, setConviteUsuario] = useState<any>(null);
  const [maxConviteArrayLength, setMaxConviteArrayLength] = useState<number>(0);

  const getConviteByEmail = useSelector((state: RootState) => state.usuarioApi.getConviteByEmail);
  const postReenviarConvite = useSelector((state: RootState) => state.usuarioApi.postReenviarConvite);
  const dispatch = useDispatch();

  const handleFindConvite = async (email: string) => {
    const convite = await getConviteByEmail(dispatch, email, true);
    setConviteUsuario(convite);
    setMaxConviteArrayLength(convite.convite.length - 1);
  };

  const handleClose = () => {
    onClose();
  };

  const handleCancelSearch = () => {
    setConviteUsuario(null);
  };

  const handleSubmit = async () => {
    if (conviteUsuario.usuario === undefined) {
      await postReenviarConvite(dispatch, conviteUsuario.convite[maxConviteArrayLength], true);
      dispatch(addAlert({ severity: 'success', message: 'O convite foi reenviado. Quando o convite for aceito o novo usuário deve aparecer na listagem.' }));
      handleCancelSearch();
      handleClose();
      return;
    } else {
      dispatch(addAlert({ severity: 'error', message: 'Este usuário já aceitou o convite e está ativo na plataforma.' }));
      return;
    }
  }

  const createCheckboxItem = (checked: boolean, label: string) => (
    <Grid item xs={12}>
      <Checkbox
        color="primary"
        checked={checked}
        readOnly
        icon={checked ? (
          <CheckCircleOutline style={{ color: 'green' }} />
        ) : (
          <CheckBoxOutlineBlank style={{ color: 'grey' }} />
        )}
      />
      {label}
    </Grid>
  );

  return (
    <Drawer open={open} onClose={handleClose} PaperProps={{ style: { padding: '40px', width: 465 } }} anchor="right">
      <Typography variant="h3">Reenvio de Convites</Typography>
      <SmSpace />
      <Divider variant="fullWidth" />
      <SmSpace />
      {conviteUsuario === null && (
        <>
          <TextField
            label="Consultar E-mail"
            required
            value={email}
            onChange={(email) => setEmail(email)}
          />
          <SmSpace />
          <Grid item xs={12}>
            <Button
              fullWidth
              variant="contained"
              color="primary"
              onClick={() => handleFindConvite(email)}
            >
              Buscar
            </Button>
          </Grid>
        </>
      )}

      {conviteUsuario !== null && (
        <>
          <Grid alignItems="center">
            <Typography variant="body1">{"Convite"}</Typography>
            <SmSpace />
            <Grid item xs={12}>
              <TextField
                label="Nome"
                required
                value={conviteUsuario.convite[maxConviteArrayLength].nome}
                disabled
              />
            </Grid>
            <SmSpace />
            <Grid item xs={12}>
              <DatePicker
                label="Data de Criação"
                required
                value={conviteUsuario.convite[maxConviteArrayLength].dataDeCriacao}
                disabled
                onChange={() => { }}
              />
            </Grid>
            <SmSpace />
            <Grid item xs={12}>
              <TextField
                label="E-mail"
                required
                value={conviteUsuario.convite[maxConviteArrayLength].email}
                disabled
              />
            </Grid>
            <SmSpace />
            {createCheckboxItem(conviteUsuario.convite[maxConviteArrayLength].ativo, ' Convite Ativo')}
            
            <SmSpace />
            <Divider variant="fullWidth" />
            <SmSpace />
            <Typography variant="body1">{"Usuário"}</Typography>

            {conviteUsuario.usuario === undefined ? (
              <>
                {createCheckboxItem(false, 'Usuário cadastrado')}
              </>
            ) : (
              <>
                {createCheckboxItem(true, 'Usuário cadastrado')}
                {createCheckboxItem(conviteUsuario.usuario.ativo, 'Usuário Ativo')}
                {!conviteUsuario.usuario.ativo && (
                  <>
                    {createCheckboxItem(conviteUsuario.usuario.suspenso, 'Usuário Suspenso')}
                    {createCheckboxItem(conviteUsuario.usuario.excluido, 'Usuário Excluido')}
                  </>
                )}
              </>
            )}

            <SmSpace />
            <Grid item xs={12}>
              <Button
                fullWidth
                variant="contained"
                color="primary"
                disabled={conviteUsuario.usuario !== undefined}
                onClick={() => handleSubmit()}
              >
                Reenviar Convite
              </Button>
            </Grid>

            <SmSpace />
            <Grid item xs={12}>
              <Button
                fullWidth
                variant="contained"
                color="error"
                onClick={() => handleCancelSearch()}
              >
                Cancelar
              </Button>
            </Grid>
            
            {conviteUsuario.usuario?.ativo && (
              <><MdSpace /><div style={{ backgroundColor: colors.yellow[100] }}>
                <span>
                  <WarningSign message='Este usuário já aceitou o convite e está ativo na plataforma.' />
                </span>
              </div></>
            )}            
          </Grid>
        </>
      )}
    </Drawer>
  );
};

export default ReenviarConviteDrawer;